/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */
import { InputStateNormalConfig } from './general.model';

export interface GcsValue {
  readonly ocularResponse?: number;
  readonly oralResponse?: number;
  readonly motoricResponse?: number;
}
export type GcsConfig = {
  readonly ocularResponse: GcsConfigOption;
  readonly oralResponse: GcsConfigOption;
  readonly motoricResponse: GcsConfigOption;
} & InputStateNormalConfig;

export interface GcsConfigOption {
  readonly label: string;
  readonly reactions: readonly { readonly label: string }[];
}

export const GCS_NORMAL_STATE = {
  ocularResponse: 4,
  oralResponse: 5,
  motoricResponse: 6,
};

export function isNormalGcs(value: GcsValue | null): boolean {
  return (
    value?.ocularResponse === GCS_NORMAL_STATE.ocularResponse &&
    value?.oralResponse === GCS_NORMAL_STATE.oralResponse &&
    value?.motoricResponse === GCS_NORMAL_STATE.motoricResponse
  );
}

export function isGcsRecordDeletable(value: GcsValue | null) {
  return value?.ocularResponse == null && value?.oralResponse == null && value?.motoricResponse === null;
}

export type GcsType = 'gcs';
